// main.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Firebase
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';

// Routing
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app/app.routes';

// App Config
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, {
  providers: [
    ...appConfig.providers,

    // Routing with hash (important for Android WebView)
    provideRouter(routes, withHashLocation()),

    // Firebase initialization
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideDatabase(() => getDatabase()), // Realtime Database
    provideMessaging(() => getMessaging()), // Cloud Messaging
  ]
})
.catch(err => console.error(err));
